export default __webpack_public_path__ + "images/JE.85cd812.png";